import { Module } from 'vuex'
import { ILoginState } from '@/store/login/types'
import { IRootState } from '@/store/types'
import { accountLoginRequest } from '@/service/login/login'
import { IAccount } from '@/service/login/loginType'
import { getKeyRequest } from '@/service/common/common'
import { JSEncrypt } from 'jsencrypt'
import { mapMenusToPermissions, mapMenusToRoutes } from '@/utils/map-menus'
import {
  requestAccountByEmpNo,
  requestAccountMenu
} from '@/service/account/account'
import localCache from '@/utils/cache'
import router from '@/router'
import { listWithEmp } from '@/service/main/promotion/access'

const loginModule: Module<ILoginState, IRootState> = {
  namespaced: true,
  state() {
    return {
      token: '',
      userInfo: {},
      userMenu: [],
      permissions: [],
      depts: []
    }
  },
  mutations: {
    changeToken(state, token: string) {
      state.token = token
    },
    changeUserInfo(state, userInfo: any) {
      state.userInfo = userInfo
    },
    changeDepts(state, depts: any[]) {
      state.depts = depts
    },
    changeUserMenu(state, menuInfo: any) {
      const routes = mapMenusToRoutes(menuInfo)
      routes.forEach((route) => {
        router.addRoute('main', route)
      })

      const permissions = mapMenusToPermissions(menuInfo)
      state.permissions = permissions
      state.userMenu = menuInfo
    }
  },
  actions: {
    resetToken({ commit }) {
      return new Promise((resolve) => {
        commit('changeToken', '')
        commit('changeUserMenu', [])
        commit('userInfo', {})
        localCache.deleteKey('token')
        localCache.deleteKey('userInfo')
        localCache.deleteKey('userMenu')
        localCache.deleteKey('depts')
        resolve(1)
      })
    },
    async accountLoginAction({ commit }, payload: IAccount) {
      const key = await getKeyRequest()
      //新建JSEncrypt对象
      const encryptor = new JSEncrypt()
      // 设置公钥
      encryptor.setPublicKey(key)
      // 加密密码
      payload.password = encryptor.encrypt(payload.password).toString()
      // 登陆
      const loginResult = await accountLoginRequest(payload)
      const { token, empNo } = loginResult
      localCache.setCache('token', token)
      commit('changeToken', token)
      //获取账户信息
      const accountInfo = await requestAccountByEmpNo(empNo)
      commit('changeUserInfo', accountInfo)
      localCache.setCache('userInfo', accountInfo)

      //获取菜单信息
      const accountMenu = await requestAccountMenu(empNo)
      commit('changeUserMenu', accountMenu)
      localCache.setCache('userMenu', accountMenu)

      if (accountInfo.isManager == '1') {
        //获取管理的部门信息
        const depts = await listWithEmp()
        commit('changeDepts', depts)
        localCache.setCache('depts', depts)
      }
      await router.push('/')
    },
    loadLocalAction({ commit }) {
      const token = localCache.getCache('token')
      if (token) {
        commit('changeToken', token)
      }
      const userInfo = localCache.getCache('userInfo')
      if (userInfo) {
        commit('changeUserInfo', userInfo)
      }
      const userMenu = localCache.getCache('userMenu')
      if (userMenu) {
        commit('changeUserMenu', userMenu)
      }
      const depts = localCache.getCache('depts')
      if (depts) {
        commit('changeDepts', depts)
      }
    }
  }
}

export default loginModule
